
import { PropTypes } from 'prop-types';
const ContainerLayout = ({ color = "bg-white text-slate-900", children }) => {
    return (
        <div className={`relative  py-12  w-full md:px-32 p-6 flex flex-col  gap-8 ${color}`}>
            {
                children
            
            }
        </div>
    )
}
ContainerLayout.propTypes = {
    color: PropTypes.string,
    children: PropTypes.node.isRequired
}
export default ContainerLayout